/* eslint-disable import/no-cycle */
import Settings from '@/settings';
import Urls from '@/settings/urls';
import Router from '@/router';

import {
  GetMailTypes,
  GetCountryList,
  GetCountryData,
  GetCurrencyList,
  GetProvider,
  UpdateProvider,
  UpdateProviderLogo,
  GetReminders,
  MarkRemsAsRead,
  GetNotifications,
  MarkNotifsAsRead,
  MarkAnnounsAsRead,
  CreateNotification,
  UpdateNotification,
  RemoveNotification,
  GetAnnouncements,
  CreateAnnouncement,
  UpdateAnnouncement,
  RemoveAnnouncement,
  GetMassEmails,
  CreateMassEmail,
  CreateErrorTicket,
  GetErrorTickets,
  ChangeErrorTicket
} from '@/api/general-data';

const tokenExpired = (exp) => {

  if (!exp) {
    return true;
  }

  const expirationDate = new Date(exp);
  let now = new Date();

  now.setSeconds(now.getSeconds() + 15);

  return now >= expirationDate;
};

export const CheckAuth = ({getters, dispatch}, forceRefresh) => {
  return new Promise((resolve, reject) => {
    let access = getters['auth/access'];

    if (access.refresh_token) {
      if (!access.token || tokenExpired(access.expire) || forceRefresh) {
        dispatch('auth/refresh', access.refresh_token)
          .then(() => resolve(getters['auth/user']));
      } else {
        resolve(getters['auth/user']);
      }
    } else {
      reject("Not Authorized to access this resource");
    }
  });
}

export const checkIsMobile = ({ commit }) => {
  commit('SET_IS_MOBILE', window.innerWidth <= Settings.breakpoints.tiny);
};

export const getMailTypes = ({ commit, dispatch }) => dispatch('CheckAuth')
  .then(() => GetMailTypes()
    .then((types) => {
      commit('SAVE_MAIL_TYPES', types);
      return types;
    }))
  .catch((e) => {
    console.log('err check auth on getMailTypes', e);
  });

export const getCountryList = ({commit, state}) => {
  let cList = localStorage.getItem('countryList');
  if (cList && cList.length)
    commit('SAVE_COUNTRY_LIST', JSON.parse(cList));

  return GetCountryList()
    .then((list) => {
      commit('SAVE_COUNTRY_LIST', list);
    })
    .catch((e) => {
      console.log('err on getCountryList', e);
    });
}


export const getCountryById = ({commit, state}, id) => {
    return GetCountryData(id)
      .then(data => {
        return data;
      })
      .catch((e) => {
        console.log('err on getCountryById', e);
      });
}

export const getStateList = ({commit, state}, id) => {
  const country = state.countryList.find(c => c.id == id);
  if (!country.states) {
    return GetCountryData(id)
      .then(data => {
        commit('SAVE_COUNTRY_DATA', data);

        return data.states;
      })
      .catch((e) => {
        console.log('err on getStateList', e);
      });
  } else {
    return new Promise((res, rej) => {
      res(country.states);
    });
  }
}

export const getTaxesList = ({commit, state}, data) => {
  return GetCountryData(data.country_id)
    .then(res => {
      commit('SAVE_COUNTRY_DATA', res);

      let taxes = res.taxes;

      if (data.state_id && res.states) {
        let currentState = res.states.find(s => s.id == data.state_id);

        if (currentState && currentState.taxes)
          taxes = [...taxes, ...currentState.taxes];
      }
      
      return taxes;
    })
    .catch((e) => {
      console.log('err on getTaxesList', e);
    });
}

export const getCurrencies = ({commit}) => {
  let curList = localStorage.getItem('currencyList');

  if (curList && curList.length && curList !== 'undefined')
    commit('SAVE_CURRENCY_LIST', JSON.parse(curList));

  return GetCurrencyList()
    .then((list) => {
      commit('SAVE_CURRENCY_LIST', list.currencies);
    })
    .catch((e) => {
      console.log('err on GetCurrencyList', e);
    });
}

export const getProvider = ({commit, state} , forceRefetch = false) => {
  return new Promise((resolve, reject) => {
    if (Object.keys(state.provider).length && !forceRefetch) {
      resolve(state.provider);
    } else {
      GetProvider()
        .then((provider) => {
          commit('SAVE_PROVIDER', provider);
          resolve(provider);
        })
        .catch(e => {
          if(e.response) {
            window.location.href = Urls.links.home;
          } else {
            console.log('No respnose, redirect to reload page');
            Router.push('/reload');
          }
        });
    }
  });
}

export const updateProvider = ({ commit, dispatch }, data) => dispatch('CheckAuth')
  .then(() => UpdateProvider(data)
    .then(res => {
      commit('SAVE_PROVIDER', res);
      return res;
    })
    .catch(e => new Promise((resolve, reject) => {
      reject(e);
    }))
  )

export const updateProviderLogo = ({ commit, dispatch }, data) => dispatch('CheckAuth')
  .then(() => UpdateProviderLogo(data)
    .then(res => {
      commit('SAVE_PROVIDER', res);
      return res;
    })
    .catch(e => {
      console.log('update provider logo error', e, e.response);
    })
  )

export const showGlobalNotification = ({commit}, data) => {
  commit('UPDATE_GLOBAL_NOTIFICATION', data);
}

export const setIsAdmin = ({commit}, val) => {
  commit('SET_IS_ADMIN', val);
}

export const setPopupState = ({commit}, val) => {
  commit('SET_POPUP_STATE', val);
}

export const getReminders = ({commit, dispatch}, query = '') => dispatch('CheckAuth')
  .then(() => GetReminders(query)
    .then(res => {
      commit('SAVE_REMINDERS_LIST', res);
      return res;
    })
    .catch(e => {
      console.log('get reminders list error', e, e.response);
    })
  );

export const markRemsAsRead = ({commit, dispatch}) => dispatch('CheckAuth')
  .then(() => MarkRemsAsRead()
    .then(res => {
      commit('SET_REMINDERS_READ');
      return res;
    })
    .catch(e => {
      console.log('get reminders list error', e, e.response);
    })
  );

export const getNotifications = ({commit, dispatch}, query = '') => dispatch('CheckAuth')
  .then(() => GetNotifications(query)
    .then(res => {
      commit('SAVE_NOTIFICATIONS_LIST', res);

      return res;
    })
    .catch(e => {
      console.log('get notifications list error', e, e.response);
    })
  );

export const markNotifsAsRead = ({commit, dispatch}) => dispatch('CheckAuth')
  .then(() => MarkNotifsAsRead()
    .then(res => {
      commit('SET_NOTIFICATIONS_READ');
      return res;
    })
    .catch(e => {
      console.log('get notifications list error', e, e.response);
    })
  );

export const createNotification = ({commit, dispatch}, data) => dispatch('CheckAuth')
  .then(() => CreateNotification(data)
    .then(res => {
      commit('ADD_NOTIFICATION', res.notification);
      return res;
    })
    .catch(e => {
      console.log('create notification error', e, e.response);
    })
  );

export const updateNotification = ({commit, dispatch}, data) => dispatch('CheckAuth')
  .then(() => UpdateNotification(data)
    .then(res => {
      commit('UPDATE_NOTIFICATION', res.notification);
      return res;
    })
    .catch(e => {
      console.log('update notification error', e, e.response);
    })
  );

export const removeNotification = ({commit, dispatch}, id) => dispatch('CheckAuth')
  .then(() => RemoveNotification(id)
    .then(res => {
      commit('REMOVE_NOTIFICATION', id);
      return res;
    })
    .catch(e => {
      console.log('remove notification error', e, e.response);
    })
  );


export const getAnnouncements = ({commit, dispatch , state}, query = '') => dispatch('CheckAuth')
  .then(() => {
    const privileged_user = state.auth.user.privileged_user
    GetAnnouncements(query , privileged_user)
    .then(res => {
      commit('SAVE_ANNOUNCEMENTS_LIST', res);

      return res;
    })
    .catch(e => {
      console.log('get announcements list error', e, e.response);
    })}
  );

  export const createAnnouncement = ({commit, dispatch}, data) => dispatch('CheckAuth')
  .then(() => CreateAnnouncement(data)
    .then(res => {
      commit('ADD_ANNOUNCEMENT', res.announcement);
      return res;
    })
    .catch(e => {
      console.log('create announcement error', e, e.response);
    })
  );

export const updateAnnouncement = ({commit, dispatch}, data) => dispatch('CheckAuth')
  .then(() => UpdateAnnouncement(data)
    .then(res => {
      commit('UPDATE_ANNOUNCEMENT', res.announcement);
      return res;
    })
    .catch(e => {
      console.log('update announcement error', e, e.response);
    })
  );

export const removeAnnouncement = ({commit, dispatch}, id) => dispatch('CheckAuth')
  .then(() => RemoveAnnouncement(id)
    .then(res => {
      commit('REMOVE_ANNOUNCEMENT', id);
      return res;
    })
    .catch(e => {
      console.log('remove announcement error', e, e.response);
    })
  );


export const markAnnounsAsRead = ({commit, dispatch}) => dispatch('CheckAuth')
  .then(() => MarkAnnounsAsRead()
    .then(res => {
      commit('SET_ANNOUNCEMENTS_READ');
      return res;
    })
    .catch(e => {
      console.log('get announcements list error', e, e.response);
    })
  );

  export const getMassEmails = ({commit, dispatch}, query = '') => dispatch('CheckAuth')
  .then(() => GetMassEmails(query)
    .then(res => {
      return res;
    })
    .catch(e => {
      console.log('get mass emails list error', e, e.response);
    })
  );


  export const createMassEmail = ({commit, dispatch}, data) => dispatch('CheckAuth')
  .then(() => CreateMassEmail(data)
    .then(res => {
      return res;
    })
    .catch(e => {
      console.log('create mass email error', e, e.response);
    })
  );


export const addApiError = ({getters, commit}, data) => {
  let provider = getters['provider'];
  let user = getters['auth/user'];

  commit('ADD_API_ERROR', {
    id: `_${Math.random().toString(36).substr(2, 9)}`,
    ...data
  });
}

export const removeApiError = ({commit}, id) => {
  commit('REMOVE_API_ERROR', id);
}

export const createTicket = ({commit, dispatch}, data) => dispatch('CheckAuth')
  .then(() => CreateErrorTicket(data)
    .then(res => {
      return res;
    })
    .catch(e => {
      console.log('can\'t create ticket', e, e.response);
    })
  )

export const getTickets = ({commit, dispatch}, params = {}) => dispatch('CheckAuth')
  .then(() => GetErrorTickets(params)
    .then(res => {
      return res;
    })
    .catch(e => {
      console.log('can\'t get tickets list', e, e.response);
    })
  )

export const changeTicket = ({commit, dispatch}, data) => dispatch('CheckAuth')
  .then(() => ChangeErrorTicket(data)
    .then(res => {
      return res;
    })
    .catch(e => {
      console.log('can\'t change ticket', e, e.response);
    })
  )
